<div id="printq_app">
  <div v-if="$printqGlobalOptions.widgetMode" class="qrcode-app">
    <HomePage v-if="userReady"></HomePage>
  </div>
  <div v-else class="qrcode-app">
    <router-view v-if="userReady"></router-view>
  </div>
</div>